import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Separator } from '@/components/ui/separator';
import { Settings2, Wifi, AtSign } from 'lucide-react';
import { LogoPicker } from './LogoPicker';

const PER_PAGE = ['1', '2', '4', '6'];

const Toggle = ({ id, label, checked, onChange }) => (
  <div className="flex items-center justify-between">
    <Label htmlFor={id} className="text-sm">{label}</Label>
    <Switch id={id} data-testid={id} checked={checked} onCheckedChange={onChange} />
  </div>
);

export const SheetConfigPanel = ({ config, setConfig, logo }) => {
  const set = (key) => (v) => setConfig(c => ({ ...c, [key]: v }));
  const setInput = (key) => (e) => setConfig(c => ({ ...c, [key]: e.target.value }));
  return (
    <Card data-testid="qr-sheet-config">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><Settings2 className="w-4 h-4" />Configuración</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label className="text-sm">Carteles por hoja A4</Label>
          <div className="grid grid-cols-4 gap-2">
            {PER_PAGE.map(n => (
              <button key={n} type="button" data-testid={`qr-per-page-${n}`} onClick={() => set('perPage')(n)}
                className={`py-2 rounded-md border-2 font-bold transition-colors ${config.perPage === n ? 'border-primary bg-primary/10' : 'border-border hover:border-primary/40'}`}>
                {n}
              </button>
            ))}
          </div>
        </div>
        <Toggle id="qr-toggle-cut-marks" label="Marcas de corte" checked={config.cutMarks} onChange={set('cutMarks')} />
        <Separator />
        <LogoPicker {...logo} source={config.logoSource} onSource={set('logoSource')} />
        <Separator />
        <div className="space-y-3">
          <Toggle id="qr-toggle-business" label="Nombre del negocio" checked={config.showBusinessName} onChange={set('showBusinessName')} />
          <Toggle id="qr-toggle-space" label="Nombre del espacio" checked={config.showSpaceName} onChange={set('showSpaceName')} />
          <Toggle id="qr-toggle-unit" label="Número / nombre de mesa" checked={config.showUnitName} onChange={set('showUnitName')} />
          <Toggle id="qr-toggle-phrase" label="Frase" checked={config.showInstructions} onChange={set('showInstructions')} />
          {config.showInstructions && (
            <Input data-testid="qr-phrase-input" value={config.instructionsText} onChange={setInput('instructionsText')} placeholder="Escaneá y pedí" maxLength={40} />
          )}
        </div>
        <Separator />
        <div className="space-y-2">
          <Label className="text-sm flex items-center gap-2"><Wifi className="w-4 h-4" />Wi-Fi (opcional)</Label>
          <Input data-testid="qr-wifi-input" value={config.wifiText} onChange={setInput('wifiText')} placeholder="WiFi: MiLocal · Clave: 1234" maxLength={50} />
          <Label className="text-sm flex items-center gap-2 pt-1"><AtSign className="w-4 h-4" />Redes sociales (opcional)</Label>
          <Input data-testid="qr-social-input" value={config.socialText} onChange={setInput('socialText')} placeholder="@milocal" maxLength={50} />
        </div>
        <Separator />
        <div className="space-y-2">
          <Label className="text-sm">Color del QR</Label>
          <div className="flex gap-2">
            <input type="color" data-testid="qr-color-picker" value={config.qrColor} onChange={setInput('qrColor')} className="w-10 h-9 p-0.5 rounded cursor-pointer border bg-transparent [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:border-0 [&::-webkit-color-swatch]:rounded" />
            <Input data-testid="qr-color-input" value={config.qrColor} onChange={setInput('qrColor')} className="flex-1 font-mono text-sm" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
